import React from 'react';
import { TaskStatus } from '../hooks/useTaskStatus';

interface TaskStatusIndicatorProps {
  status: TaskStatus;
  className?: string;
}

const TASK_BADGE: Record<TaskStatus, { badge: string; label: string }> = {
  none: { badge: 'badge-warning', label: 'Sem tarefa' },
  overdue: { badge: 'badge-warning', label: 'Tarefa vencida' },
  ok: { badge: 'badge-success', label: 'Tarefa em dia' },
};

export const TaskStatusIndicator: React.FC<TaskStatusIndicatorProps> = ({ status, className = '' }) => {
  const { badge, label } = TASK_BADGE[status];

  return (
    <span className={`badge badge-sm ${badge} ${className}`.trim()}>
      {label}
    </span>
  );
};
